import mod from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/import-glob/index.js!./SiteHeader.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/import-glob/index.js!./SiteHeader.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteHeader.vue?vue&type=script&lang=js&
// module id = 5
// module chunks = 0